import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var updateCookiesRes;
export const updateCookiesTodo = createAsyncThunk('updateCookies', async (data) => {
    // console.log("data", data)
    const cookies_id = localStorage.getItem("unique_id");
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL + `cookie_log/${cookies_id}`,
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return updateCookiesRes = res

    } catch (error) {
        return updateCookiesRes = error.response
    }
})